import React, { useState } from "react";
import { Button, Modal, Tooltip } from "antd";

import { ENUM_PERSONAL_SITE } from "../../enum";
import ICON_ERROR from "../../assets/error.svg";

import type { TypeEditPreviewProps } from "..";

interface TypePublishProps extends Pick<TypeEditPreviewProps, "sync"> {
  status?: ENUM_PERSONAL_SITE.STATUS;
  onClick(): Promise<void>;
}

/**
 * @name Publish 发布、取消发布˝
 */
const Publish: React.FC<TypePublishProps> = ({ sync, status, onClick }) => {
  const [load, setLoad] = useState(false);
  const [open, setOpen] = useState(false);

  const HIDE_BTN = [
    ENUM_PERSONAL_SITE.STATUS.ACTIVATED,
    ENUM_PERSONAL_SITE.STATUS.DEACTIVATED,
  ].includes(status);

  const IS_ACTIVATED = status === ENUM_PERSONAL_SITE.STATUS.ACTIVATED;

  async function onPublish() {
    try {
      setLoad(true);
      if (IS_ACTIVATED) {
        // "Unpublish" 先警告用户，二次确认
        setOpen(true);
      } else {
        await onClick();
      }
    } catch (e) {
    } finally {
      setLoad(false);
    }
  }

  function onRemoveListing() {
    onClick?.();
    setOpen(false);
  }

  return (
    <>
      {HIDE_BTN && (
        <Tooltip
          title={
            sync ? "Data synchronization in progress, nearing completion" : ""
          }
        >
          <Button
            loading={load}
            type="primary"
            onClick={onPublish}
            ghost={IS_ACTIVATED}
            disabled={sync || load}
          >
            {IS_ACTIVATED ? "Unpublish" : "Publish"}
          </Button>
        </Tooltip>
      )}
      <Modal
        open={open}
        width={500}
        footer={null}
        closable={false}
        className="website-unpublish-warn"
      >
        <img draggable="false" src="/website-unpublish.png" />
        <div>
          <h4>Don't lose your Verified Status.</h4>
          <ul>
            <li>
              <img src={ICON_ERROR} />
              Miss out on qualified borrower leads.
            </li>
            <li>
              <img src={ICON_ERROR} />
              Lose your 100% free marketplace profile.
            </li>
            <li>
              <img src={ICON_ERROR} />
              Disconnect from borrowers searching for you.
            </li>
          </ul>
          <p>
            It <span>costs $0</span> to keep. Why not let it run?
          </p>

          <Button onClick={() => setOpen(false)} type="primary">
            Stay listed
          </Button>

          <Button onClick={onRemoveListing} type="link">
            No thanks, remove my listing.
          </Button>

          <p>
            You can manage your profile visibility anytime from your Zeitro
            dashboard.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default Publish;
